export const MEMO_MAX_LENGTH = 200;
export const MEMO_MIN_LENGTH = 0;
export const TITLE_MAX_LENGTH = 20;
export const TITLE_MIN_LENGTH = 1;
